import {
  BasicTableDataRow,
  FormTemplate,
  TableCellContentAlignEnum,
} from '@employ-engage/data';
import { Dispatch, FC, SetStateAction } from 'react';
import Modal from '../modal/modal';
import { Table } from '../table';
import { Button } from '../button/button';
import { GET_ALL_FORM_VERSIONS_FOR_TEMPLATE } from '../api';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';

interface VersionsModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedTemplate: FormTemplate | null;
}

export const VersionsModal: FC<VersionsModalProps> = ({
  open,
  setOpen,
  selectedTemplate,
}) => {
  const { t } = useTranslation(['common']);
  const { loading, data: { getFormVersionsByTemplateId: versions = [] } = {} } =
    useQuery(GET_ALL_FORM_VERSIONS_FOR_TEMPLATE, {
      variables: {
        templateId: selectedTemplate?.id || '',
      },
      skip: !selectedTemplate,
    });

  if (loading) {
    return <LoadingSpinner spinnerId="versions-modal-loading" makeAbsolute />;
  }

  return (
    <Modal open={open} setOpen={setOpen} panelClassName="w-[800px] max-w-full">
      <h2 className="text-lg font-semibold">{t('Versions')}</h2>
      <Table
        headerList={[
          {
            id: 'name',
            headerLabel: t('Name'),
          },
          { id: 'createdAt', headerLabel: t('Created At') },
          {
            id: 'status',
            headerLabel: t('Status'),
            alignment: TableCellContentAlignEnum.CENTER,
          },
        ]}
        dataList={
          [...versions].sort((a: any, b: any) => {
            return (
              new Date(b.createdAt).getMilliseconds() -
              new Date(a.createdAt).getMilliseconds()
            );
          }) as BasicTableDataRow[]
        }
        mapData={(row, index) => {
          return {
            id: row.id,
            name: row.name,
            createdAt: row.createdAt,
            status: index === 0 ? <span>Current</span> : null,
          };
        }}
      />
      <div className="flex justify-end mt-2">
        <Button variant="danger" onClick={() => setOpen(false)}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  );
};

export default VersionsModal;
